import { ActionKeys } from '~/actions/constants';
import * as transactionsActions from '~/actions/transactions.actions';
import { AxiosResponse } from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import * as transactionsService from '~/services/transactions.service';
import { fromJSON, JSONTransaction } from '~/types/Transaction';

export function* fetchTransaction(action: ReturnType<typeof transactionsActions.fetchTransaction>) {
  try {
    const result: AxiosResponse<JSONTransaction> = yield call(
      transactionsService.get,
      action.payload.transactionId,
    );
    const parsedTransaction = fromJSON(result.data);
    yield put(transactionsActions.fetchTransactionSuccess(parsedTransaction));
  } catch (err) {
    yield put(transactionsActions.fetchTransactionError());
  }
}

export function* sendEmailNotification(
  action: ReturnType<typeof transactionsActions.sendEmailNotification>,
) {
  try {
    yield call(transactionsService.emailNotify, [action.payload.transactionId]);
    yield put(transactionsActions.sendEmailNotificationSuccess());
  } catch (err) {
    yield put(transactionsActions.sendEmailNotificationError());
  }
}

export function* refundTransaction(
  action: ReturnType<typeof transactionsActions.refundTransaction>,
) {
  try {
    yield call(transactionsService.refund, action.payload.transactionId);
    yield put(transactionsActions.refundTransactionSuccess());
  } catch (err) {
    yield put(transactionsActions.refundTransactionError());
  }
}

export default [
  takeEvery(ActionKeys.FETCH_TRANSACTION, fetchTransaction),
  takeEvery(ActionKeys.SEND_EMAIL_NOTIFICATION, sendEmailNotification),
  takeEvery(ActionKeys.REFUND_TRANSACTION, refundTransaction),
];
